import * as ActionTypes from "services/state/action-types";

const initialState = {
  sensediaToken: "",
  loginError: false,
};

const oAuthSensedia = (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.SENSEDIA_ACCESS_TOKEN: {
      return {
        ...state,
        sensediaToken: payload,
      };
    }
    default:
      return state;
  }
};

export default oAuthSensedia;



// WEBPACK FOOTER //
// ./src/services/state/sensedia/reducer.js